import React from 'react';
import he from 'he';
import axios from 'axios';
import { Button, Input, Collapse, Card, Modal, Popconfirm, Tag, Alert, message } from 'antd';

import apiPath from 'apiPath';
import moment from 'components/momentWithZone';
import PaymentTriggerForm from 'components/PaymentTriggerForm';
import stickyError from 'components/stickyError';
import checkConflicts from '../checkConflicts';
import loadFieldPrograms from '../loadFieldPrograms';
import parseJSON from '../parseJSON';

class CheckoutForm extends React.Component {
	state = {
		cartToCharge: []
	}
	preCheckout = () => {
		return new Promise((resolve, reject) => {
			this.props.stockCheck().then(itemIds => {
				// add the items to the booking
				axios.put(apiPath + '/items', {
					items: this.props.cart.map(program => {
						const item = this.props.inventory[program.Code];
						return {
							ItemId: itemIds[program.Code],
							BegDate: item.start.split('T')[0] + 'T00:00:00',
							EndDate: item.end.split('T')[0] + 'T00:00:00',
							BegLocation: item.BegLocation,
							EndLocation: item.EndLocation, 
							Price: item.price
						}
					})
				}, {
						withCredentials: true
					}).then(result => {
						localStorage.removeItem('fieldProgramCart');
						resolve();
					}).catch(error => {
						if (error.response.status === 403) {
							this.props.kickSession();
							reject();
						} else if (error.response.status === 409) {
							this.props.onPartialResult(error.response.data);
							if (error.response.data.succeeded.length) {
								const succeeded = error.response.data.succeeded;

								// remove unavailable programs from cart to charge
								let cart = this.props.cart.slice();
								cart = cart.filter(cartItem => succeeded.indexOf(itemIds[cartItem.Code]) !== -1);
								this.setState({ cartToCharge: cart });

								// send to payment in 5 seconds
								window.setTimeout(() => resolve(), 5000);

							} else {
								reject({ message: 'Programs unavailable' });
							}
						} else if (error.response.data) {
							reject({ message: error.response.data });
						} else {
							reject(error);
						}
					});
			}).catch(error => {
				reject(error);
			});
		});
	}
	componentDidMount() { this.setState({ cartToCharge: this.props.cart }); }
	componentWillReceiveProps(nextProps) { this.setState({ cartToCharge: nextProps.cart }); }
	render() {


		let i = 0;
		const isTemporarilyFree = false;
		const total = (this.props.isEarlyBooking || isTemporarilyFree) ? 0 : this.props.total;
		return (
			<PaymentTriggerForm 
				kickSession={this.props.kickSession}
				disabled={this.props.disabled}
				buttonText={(this.props.isEarlyBooking) ? 'Reserve Programs' : 'Purchase Programs'}
				showIcon={!this.props.isEarlyBooking}
				buttonSize="large"
				orderno_prefix="FLD"
				preCheckout={this.preCheckout}
				refreshBooking={this.props.refreshBooking}
				cust_id={this.props.folio.RepeaterNo}
				booking={this.props.booking}
				client_email={this.props.folio.Email1}
				redirectIfFree={"/portal/field/Registered?clearCart=true"}
				childDiscount={this.props.childDiscount}
				total={total}>

				{this.state.cartToCharge.map(program => {
					i++;
					let price = this.props.inventory[program.Code].price;
					if (this.props.childDiscount) price /= 2;
					return (
						<div key={program.ExcursionId}>
							<input type="hidden" name={'li_id' + i} value={program.ExcursionId} />
							<input type="hidden" name={'li_description' + i} value={he.decode(program.Title)} />
							<input type="hidden" name={'li_quantity' + i} value="1" />
							<input type="hidden" name={'li_price' + i} value={
								parseFloat(Math.round(price * 100) / 100).toFixed(2)} />
						</div>
					);
				})}

			</PaymentTriggerForm>
		);
	}
}

export default class Checkout extends React.Component {
	state = {
		cart: [],
		checking: false,
		confirming: false,
		inventory: {},
		IDtoCode: {},
		chargeTotal: null,
		creditTotal: null,
		partialResult: null,
		childDiscount: false,
		//SP19 DATE?!
		showSpotsLeft: moment().isAfter('2018-10-24T09:00')
	}
	getCart = () => this.setState({ cart: parseJSON(localStorage.fieldProgramCart, []) });
	getBalance = (props) => {
		if (props.bookingLoaded) {
			this.setState({
				chargeTotal: props.fieldChargeTotal,
				creditTotal: props.fieldCreditTotal
				// chargeTotal: props.chargeTotal,
				// creditTotal: props.creditTotal
			});
		}
	}
	getInventory = () => {
		axios.get(apiPath + '/fieldprograms').then(result => {
			let inventory = {};
			let IDtoCode = {};
			let maxPrice = 0;
			let todaydate = moment();

			let blah = result.data.sort((a, b) => {
				const aVal = a.isCurrentPrice ? 1 : 0;
				const bVal = b.isCurrentPrice ? 1 : 0;
				return aVal - bVal
			}).map(item => {
				if (!item.Visible || item.EventId !== this.props.booking.EventId)
					return null;
				IDtoCode[item.ItemId] = item.Code;
				const price = parseFloat(item.Price);
				const start = item.BegDate;
				const end = item.EndDate;

				var theitcenddate = moment(item.itcValidEndDate).add(1, "days").subtract(1, "seconds");
                if (price > maxPrice) maxPrice = price;
                //check if in inventory already
                if(inventory[item.Code] != null){
                    var inventoryitcEndDate = inventory[item.Code].itcValidEndDate;
                    // var inventoryitcEndDate = moment(inventory[item.Code].itcValidEndDate).add(1, "days").subtract(1, "seconds").format("YYYY-MM-DD HH:mm:ss.sss");
                    // var inventoryitcEndDate = moment(inventory[item.Code].itcValidEndDate);
                    //if the itcvalidate is in the future and its closer to today, or if the inventorydate is in the past
                    if(todaydate.diff(theitcenddate.format("YYYY-MM-DD HH:mm:ss.sss")) < 0  &&  (theitcenddate.diff(inventoryitcEndDate) < 0 || todaydate.diff(inventoryitcEndDate) > 0)){
						return inventory[item.Code] = {
							ItemId: item.ItemId,
							Name: item.Name,
							available: parseInt(item.AvailItems, 10).toString(),
							price: price,
							isCurrentPrice: moment().isBetween(item.itcValidBegDate,  moment(item.itcValidEndDate).add(1, "days").subtract(1, "seconds").format("YYYY-MM-DD HH:mm:ss.sss")),
							start: start,
							end: end,
							BegLocation: item.BegLocation,
							EndLocation: item.EndLocation,
							visible: item.Visible,
							bookable: item.Enabled,
							GSCE: item.GSCE,
							duration: item.Duration,
							itcValidBegDate: item.itcValidBegDate,
							itcValidEndDate: moment(item.itcValidEndDate).add(1, "days").subtract(1, "seconds").format("YYYY-MM-DD HH:mm:ss.sss")
						};						
					}
/*
					if(item.isCurrentPrice){
						return inventory[item.Code] = {
							ItemId: item.ItemId,
							Name: item.Name,
							available: parseInt(item.AvailItems, 10).toString(),
							price: price,
							isCurrentPrice: item.isCurrentPrice,
							start: start,
							end: end,
							BegLocation: item.BegLocation,
							EndLocation: item.EndLocation,
							visible: item.Visible,
							bookable: item.Enabled,
							GSCE: item.GSCE,
							duration: item.Duration,
							itcValidBegDate: item.itcValidBegDate,
							itcValidEndDate: item.itcValidEndDate
						};
					}
					else if(!inventory[item.Code].isCurrentPrice && price > inventory[item.Code].price) {
						return inventory[item.Code] = {
							ItemId: item.ItemId,
							Name: item.Name,
							available: parseInt(item.AvailItems, 10).toString(),
							price: price,
							isCurrentPrice: item.isCurrentPrice,
							start: start,
							end: end,
							BegLocation: item.BegLocation,
							EndLocation: item.EndLocation,
							visible: item.Visible,
							bookable: item.Enabled,
							GSCE: item.GSCE,
							duration: item.Duration,
							itcValidBegDate: item.itcValidBegDate,
							itcValidEndDate: item.itcValidEndDate
						};
					}
*/
				}
				else{
					return inventory[item.Code] = {
						ItemId: item.ItemId,
						Name: item.Name,
						available: parseInt(item.AvailItems, 10).toString(),
						price: price,
						isCurrentPrice: item.isCurrentPrice,
						start: start,
						end: end,
						BegLocation: item.BegLocation,
						EndLocation: item.EndLocation,
						visible: item.Visible,
						bookable: item.Enabled,
						GSCE: item.GSCE,
						duration: item.Duration,
						itcValidBegDate: item.itcValidBegDate,
						itcValidEndDate: item.itcValidEndDate
					};
				}

/*
				return inventory[item.Code] = {
					ItemId: item.ItemId,
					Name: item.Name,
					available: parseInt(item.AvailItems, 10).toString(),
					price: price,
					isCurrentPrice: item.isCurrentPrice,
					start: start,
					end: end,
					BegLocation: item.BegLocation,
					EndLocation: item.EndLocation,
					visible: item.Visible,
					bookable: item.Enabled,
					GSCE: item.GSCE,
					duration: item.Duration,
					itcValidBegDate: item.itcValidBegDate,
					itcValidEndDate: item.itcValidEndDate
				};
*/
			});
			this.setState({
				inventory: inventory,
				IDtoCode: IDtoCode
			});
		}).catch(this.props.handleAxiosLoadError);
	}
	checkForDiscounts = () => {
		axios.get(apiPath + '/ischild', { withCredentials: true }).then(result => {
			if (result.data === true) {
				this.setState({ childDiscount: true });
			}
		}).catch(this.props.handleAxiosLoadError);
	}
	checkStock = () => {
		return new Promise((resolve, reject) => {
			this.setState({ checking: true });
			axios.get(apiPath + '/fieldprograms').then(result => {
				let availability = {};
				let itemIds = {};
				result.data.map(item => {
					availability[item.Code] = (parseInt(item.AvailItems, 10) > 0) ? 1 : 0;
					return itemIds[item.Code] = item.ItemId;
				});
				const outOfStock = this.state.cart
					.filter(program => typeof itemIds[program.Code] !== 'undefined' && availability[program.Code] < 1);

				// if it fails, show an error message
				if (outOfStock.length > 0) {
					outOfStock.map(program => {
						this.removeProgramFromCart(program, false);
						return stickyError(he.decode(program.Title) + ' is out of stock and has been removed from your cart');
					});
					this.setState({ checking: false });
					reject();
				}
				else {
					this.setState({ checking: false });
					resolve(itemIds);
				}
			}).catch(error => {
				this.setState({ checking: false });
				stickyError('Failed to check availability: ' + error.message, 3, true);
				reject();
			});
		});
	}
	addByCode = (code) => {
		let matchingPrograms = parseJSON(sessionStorage.fieldPrograms, [])
			.filter(program => program.Code === code);
		let program = matchingPrograms[0];

		checkConflicts(program, this.state.inventory, this.state.cart, this.props.bookedItems, this.state.IDtoCode).then(result => {
			localStorage.setItem('fieldProgramCart', JSON.stringify(this.state.cart.concat(program)));
			this.setState({ cart: this.state.cart.concat(program) });
			message.success(he.decode(program.Title) + ' was added to your cart');
		}).catch(conflict => {
			console.error(conflict);
			stickyError(conflict, 0, false, 'Conflict');
		});

	}
	addProgramByCode = (code) => {
		if (!sessionStorage.fieldProgramsUpdated || !sessionStorage.fieldProgramsForVoyage ||
			moment(sessionStorage.fieldProgramsUpdated, 'X').add(1, 'hours').isBefore(moment()) ||
			sessionStorage.fieldProgramsForVoyage !== (this.props.booking.EventId || this.props.booking.TripCode)) {
			loadFieldPrograms(this.props.booking.EventId).then(result => {
				this.addByCode(code);
			});
		} else {
			this.addByCode(code);
		}
	}
	removeProgramFromCart = (program, showMessage = false) => {
		let cart = this.state.cart;
		cart.splice(this.state.cart.indexOf(program), 1);
		this.setState({ confirming: false, cart: cart });
		localStorage.setItem('fieldProgramCart', JSON.stringify(cart));
		if (showMessage) message.info(he.decode(program.Title) + ' was removed from your cart');
	}
	clearCart = () => {
		localStorage.removeItem('fieldProgramCart');
		this.setState({ cart: [] });
	}
	setPartialResult = (data) => {
		this.setState({ partialResult: data });
	}
	toggleModal = () => this.setState({ confirming: !this.state.confirming });
	componentDidMount() {
		this.getCart();
		this.getInventory();
		this.checkForDiscounts();
		this.getBalance(this.props);
		
		this.checkStock();
		if (this.state.showSpotsLeft) this._interval = window.setInterval(this.checkStock, 5000);
	}
	componentWillReceiveProps(nextProps) {
		this.getBalance(nextProps);
	}
	componentWillUnmount() {
		window.clearInterval(this._interval);
	}
	render() {
		//const disabled = this.props.variant !== 'admin' && !this.props.sectionIsEnabled(this.props, 'field/checkout');
		const disabled = false;
		if (this.props.variant !== 'admin' && this.props.redirectIfHidden) {
			const redirect = this.props.redirectIfHidden(this.props, 'field/checkout');
			if (redirect) return redirect;
		}
		const rule = this.props.configRules && this.props.configRules.find(rule => rule.section === 'field/checkout' && rule.voyage === this.props.booking.EventId);
		const isEarlyBooking = (!rule)? false: (rule.enableAlways === "1")? true: 	moment().isBetween(moment.utc(rule.enableFrom), moment.utc(rule.disableAfter));


		let cartTotal = (this.state.cart.length === 0) ? 0 :
			this.state.cart
				.map(program => (this.state.inventory[program.Code]) ?
					this.state.inventory[program.Code].price : 0)
				.reduce((total, num) => parseInt(total, 10) + parseInt(num, 10));

		let { chargeTotal, creditTotal } = this.state;
		let amount = this.state.amount || chargeTotal - creditTotal;
		if (amount > chargeTotal - creditTotal) amount = chargeTotal - creditTotal;

		const accountCredit = (creditTotal > chargeTotal) ? creditTotal - chargeTotal : 0;

		cartTotal -= accountCredit;
		if (cartTotal < 0) cartTotal = 0;
		return (
			<div className="withSpacing">
				{disabled &&
					<div>
						<Alert showIcon type="warning" message="This section is currently disabled" />
						<br /><br />
					</div>
				}


{/*

				{moment().isBefore('2019-10-12') &&
				<Alert showIcon type="info"
					description={<div>
						<p><strong><u>Policies:</u></strong></p>
						<ul style={{paddingLeft:'20pt', paddingBottom: '10pt', listStyleType:'disc'}}>
						
						
							<li>Upon clicking "Confirm and Check Out", you will be prompted to click "Reserve Programs." By clicking "Reserve Programs" you are confirming you have reviewed and understand the  <a href="http://www.semesteratsea.org/wp-content/uploads/2019/08/Important-Dates-and-Deadlines_SP20.pdf" target="_blank">Field Program Cancellation policy</a> (all program cancellations incur a penalty, read policy for details).</li>
								
							<li>If you would like a PDF receipt emailed to you, please contact the Field Office at 970-491-8333 or <a href="mailto:field@isevoyages.org">field@isevoyages.org</a>. </li>
							<li>Credit card processing fees will be absorbed for Field Program purchases only.</li>
						</ul>
					</div>} />
				}




				{moment().isAfter('2019-10-11') &&
				<Alert showIcon type="info"
					description={<div>
						<p><strong><u>Policies:</u></strong></p>
						<ul style={{paddingLeft:'20pt', paddingBottom: '10pt', listStyleType:'disc'}}>
						
						
						<li>Payments are due at the time of program registration. Upon clicking "Confirm and Check Out", you will be prompted to make a payment." By selecting a payment type, you are confirming you have reviewed and understand the <a href="http://www.semesteratsea.org/wp-content/uploads/2019/08/Important-Dates-and-Deadlines_SP20.pdf" target="_blank">Field Program Cancellation policy</a>. (All program cancellations incur a penalty. Please read the linked policy for details.)</li>
						<li>Once you select a payment method, you are registered in the program. Should you close out of the payment screen, you are still registered for the program and are responsible for the program fee. Please be sure to check your "Registered" section after check out to make sure your registrations are correct.</li>
						<li>Credit card processing fees will be absorbed for Field Program purchases only. </li>
						<li>To request a PDF receipt, please contact the Field Office at <a href="mailto:field@isevoyages.org">field@isevoyages.org</a> or 970-491-8333. </li>
						</ul>
					</div>} />
				}

*/}



				<div>
					<h3>Add a program by code:</h3>
					<Input.Search
						type="text"
						size="large"
						ref="programCode"
						placeholder="ABC 123-456"
						onSearch={this.addProgramByCode} />
				</div>
				<br />
				{this.state.cart.length > 0 &&
					<div>
						<div>
							<span style={{ float: 'right' }}>
								<Popconfirm
									placement="bottomRight"
									title="Are you sure you want to clear your cart?"
									okText="Yes" cancelText="No"
									onConfirm={this.clearCart}>
									<Button type="danger" icon="delete">Clear Cart</Button>
								</Popconfirm>
							</span>
							<Button
								icon="sync"
								loading={this.state.checking}
								onClick={this.checkStock}>
								{(this.state.checking) ? 'Checking' : 'Check'} Availability
							</Button>
						</div>
						<br />
						<Collapse>
							{this.state.cart.map(program => {
								const price = (this.state.inventory[program.Code]) ?
									this.state.inventory[program.Code].price : 0;
								const available = (this.state.inventory[program.Code]) ?
									this.state.inventory[program.Code].available : 0;
								return (
									<Collapse.Panel key={program.ExcursionId}
										header={
											<div>
												<span style={{ float: 'right', margin: '0 8pt' }}>
													{this.state.showSpotsLeft &&
														<Tag color={(available < 5) ? 'red' : (available < 10) ? 'orange' : 'green'}>
															{available} spots left
														</Tag>
													}
													${price.toFixed(2)}
													<Popconfirm
														placement="left"
														title={'Are you sure you want to remove ' + he.decode(program.Title) + '?'}
														okText="Yes" cancelText="No"
														onConfirm={this.removeProgramFromCart.bind(this, program)}>
														<Button size="small" style={{ marginLeft: '4pt' }} type="danger" icon="close"
															onClick={(e) => { e.stopPropagation(); }} />
													</Popconfirm>
												</span>
												<span>{program.Code}: </span>
												<span dangerouslySetInnerHTML={{ __html: program.Title }} />
											</div>
										}>

										<p>{program.Code}</p>

										<p dangerouslySetInnerHTML={{ __html: program.Summary }} />

									</Collapse.Panel>
								);
							})}
							{accountCredit > 0 &&
								<Collapse.Panel
									header={
										<div>
											<span style={{ float: 'right', margin: '0 8pt' }}>- ${accountCredit}</span>
											<span>Account Credit</span>
										</div>
									}>
									Credit you have on your account
								</Collapse.Panel>
							}
							{this.state.childDiscount &&
								<Collapse.Panel
									header={
										<div>
											<span style={{ float: 'right', margin: '0 8pt' }}>- ${(cartTotal / 2).toFixed(2)}</span>
											<span>Child Discount (50%)</span>
										</div>
									}>
									Children get a 50% discount on all Field Programs
								</Collapse.Panel>
							}
						</Collapse>
						<Card style={{ textAlign: 'right' }}>Total: ${((this.state.childDiscount) ? cartTotal / 2 : cartTotal).toFixed(2)}</Card>
					</div>
				}
				<div style={{ textAlign: 'right' }}>
					<Button onClick={() => this.checkStock().then(() => this.toggleModal())} size="large" type="primary"
						icon="check" disabled={disabled || this.state.cart.length === 0}>
						Confirm and Check Out
					</Button>
				</div>
				<Modal
					visible={this.state.confirming}
					onCancel={this.toggleModal}
					width={window.innerWidth * (3 / 4)}
					footer={<CheckoutForm
						disabled={disabled}
						cart={this.state.cart}
						inventory={this.state.inventory}
						stockCheck={this.checkStock}
						total={cartTotal}
						folio={this.props.folio}
						booking={this.props.bookingLoaded && this.props.booking}
						childDiscount={this.state.childDiscount}
						refreshBooking={this.props.refreshBooking}
						onRemoveFromCart={this.removeProgramFromCart}
						onPartialResult={this.setPartialResult}
						kickSession={this.props.kickSession}
						isEarlyBooking={isEarlyBooking} />}>

					<h3>Are you sure?</h3>
					<p>Once you click a blue button below, you will be registered in  requested program(s). By clicking {isEarlyBooking?"\"reserve programs\"": "\"purchase programs\""} you are confirming you  have reviewed and understand the Field Program cancellation policy.</p>

					{this.state.partialResult &&
						<div>
							<br /><br />
							{this.state.partialResult.succeeded.length === 0 && <h3>Programs unavailable or already booked</h3>}
							{this.state.partialResult.succeeded.length > 0 && <h3>Processing...</h3>}
							{this.state.partialResult.succeeded.length > 0 &&
								<p>You will be directed to the payment page in 5 seconds to pay for available programs...</p>
							}

							{this.state.partialResult.succeeded.length > 0 &&
								<span>
									You are being registered for the following programs:
									<ul style={{ listStyle: 'disc', marginLeft: '16pt' }}>
										{this.state.partialResult.succeeded.map(id => <li key={id}>{this.state.IDtoCode[id]}</li>)}
									</ul>
								</span>
							}

							{this.state.partialResult.failed.length > 0 &&
								<span>
									These programs are no longer available:
									<ul style={{ listStyle: 'disc', marginLeft: '16pt' }}>
										{this.state.partialResult.failed.map(id => <li key={id}>{this.state.IDtoCode[id]}</li>)}
									</ul>
								</span>
							}

							{this.state.partialResult.alreadyBooked.length > 0 &&
								<span>
									You are already registered for these programs:
									<ul style={{ listStyle: 'disc', marginLeft: '16pt' }}>
										{this.state.partialResult.alreadyBooked.map(id => <li key={id}>{this.state.IDtoCode[id]}</li>)}
									</ul>
								</span>
							}
						</div>
					}

				</Modal>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./portal-components/Portal/FieldPrograms/Checkout/index.jsx